import { Popup } from "@omnia/shared/react/Popup";
import { getSelectedYearsLabel } from "../../utils/date";
import { YearPickerOption, YearsPopup } from "./YearsPopup";

export interface YearsPickerProps {
    /**
     * Options for the picker.
     */
    options: YearPickerOption[];
    /**
     * Event handler called when the selection is changed.
     */
    onChange: (options: YearPickerOption[]) => void;
    /**
     * If specified (and present in the options), "Current Year" will appear as a shortcut button.
     */
    currentYear?: number;
    /**
     * Whether the button is disabled.
     */
    disabled?: boolean;
}

/**
 * Displays a list of years and allows the user to select one.
 */
export const YearsPicker = ({ options, onChange, currentYear, disabled }: YearsPickerProps) => {
    const selectedYears: number[] = options.filter((year) => year.selected).map((year) => year.year);
    const yearsText: string = getSelectedYearsLabel(selectedYears, null);

    const isDisabled = disabled || options.length === 0;

    return (
        <div className="omnia-years-picker">
            <Popup
                popupCssClass="omnia-years-picker-popup"
                popupContent={YearsPopup}
                popupContentProps={() => ({
                    options: options,
                    onChange: onChange,
                    currentYear,
                })}
                align="topLeft"
                origin="bottomLeft"
                wrapper={false}
                outsideClick={true}
                disabled={isDisabled}
            >
                <button type="button" className="btn btn-link" disabled={isDisabled}>
                    <span className="years">{yearsText}</span>
                    &nbsp;
                    <span className="caret"></span>
                </button>
            </Popup>
        </div>
    );
};
